export default function loadMoreImages() {
  const gridElement = document.querySelector(".woo-archive__grid");

  if (!gridElement) return;

  // Create a MutationObserver to watch for DOM changes
  const observer = new MutationObserver(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update();
    }
  });

  // Observe the element for child list changes and subtree modifications
  observer.observe(gridElement, {
    childList: true,
    subtree: true,
  });
}
